import type * as React from 'react';

function SvgSorted(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg height="1em" viewBox="0 0 15 12" width="1em" {...props}>
      <path
        d="M4.526 9.084c.12.125.188.295.188.472 0 .176-.067.346-.188.47l-1.714 1.779c-.12.125-.284.195-.454.195-.17 0-.334-.07-.454-.195L.19 10.027c-.163-.168-.228-.414-.168-.645.059-.23.233-.41.455-.472s.46.005.622.174l.616.64V.667c0-.369.288-.667.643-.667C2.713 0 3 .298 3 .667v9.057l.616-.64c.12-.125.284-.195.455-.195.17 0 .334.07.454.195zM13.152 1.286H6.455c-.37 0-.67.3-.67.67 0 .37.3.669.67.669h6.697c.37 0 .67-.3.67-.67 0-.37-.3-.67-.67-.67zM12.259 3.91H6.455c-.37 0-.67.3-.67.67 0 .37.3.67.67.67h5.804c.37 0 .67-.3.67-.67 0-.37-.3-.67-.67-.67zM11.366 6.536h-4.91c-.37 0-.67.3-.67.67 0 .37.3.669.67.669h4.91c.37 0 .67-.3.67-.67 0-.37-.3-.67-.67-.67zM10.473 9.16H6.455c-.37 0-.67.3-.67.67 0 .37.3.67.67.67h4.018c.37 0 .67-.3.67-.67 0-.37-.3-.67-.67-.67z"
        fill="currentColor"
        fillRule="evenodd"
        transform="translate(.546)"
      />
    </svg>
  );
}

export default SvgSorted;
